import { SVGProps } from 'react';

const ContactUsMinus = ({
    ...otherProps
}: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="2" viewBox="0 0 22 2" fill="none">
        <path d="M22 1.31134e-06V2L0 2L8.74224e-08 0L22 1.31134e-06Z" fill="#2A2A2A" />
    </svg>
);

export default ContactUsMinus;


